import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class GroupsPane extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.groups = [];
    this.members = [];
    this.selectedGroupId = '';
    this.loading = false;
    this.error = '';
    this.page = 1;
    this.pages = 1;
    this.total = 0;
    this.loadGroups();
  }
  api(path) {
    return String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '') + path;
  }
  async loadGroups() {
    this.loading = true;
    this.error = '';
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/groups')
      });
      this.groups = Array.isArray(data.groups) ? data.groups : [];
    } catch (e) {
      this.error = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible de charger les groupes.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  async selectGroup(groupId, page) {
    if (page === void 0) {
      page = 1;
    }
    this.selectedGroupId = String(groupId || '');
    this.page = page;
    this.members = [];
    this.error = '';
    if (!this.selectedGroupId) {
      this.total = 0;
      this.pages = 1;
      return;
    }
    this.loading = true;
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/groups') + '?group_id=' + encodeURIComponent(this.selectedGroupId) + '&page=' + encodeURIComponent(page)
      });
      this.groups = Array.isArray(data.groups) ? data.groups : this.groups;
      this.members = Array.isArray(data.members) ? data.members : [];
      const pagination = data.pagination || {};
      this.page = Number(pagination.page || 1);
      this.pages = Number(pagination.pages || 1);
      this.total = Number(pagination.total || 0);
    } catch (e) {
      this.error = e?.response?.error || e?.response?.errors?.[0]?.detail || 'Impossible de charger les membres du groupe.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  selectedGroup() {
    return this.groups.find(group => String(group.id) === String(this.selectedGroupId)) || null;
  }
  groupName(group) {
    return group.name_plural || group.name_singular || `Groupe ${group.id}`;
  }
  formatDate(value) {
    if (!value) return '—';
    try {
      return new Intl.DateTimeFormat('fr-FR', {
        dateStyle: 'short'
      }).format(new Date(value));
    } catch (_) {
      return '—';
    }
  }
  pagination() {
    if (this.pages <= 1) return null;
    return m('.ValModerationPagination', [m('button.Button', {
      type: 'button',
      disabled: this.page <= 1 || this.loading,
      onclick: () => this.selectGroup(this.selectedGroupId, this.page - 1)
    }, '← Précédent'), m('span', `Page ${this.page} / ${this.pages}`), m('button.Button', {
      type: 'button',
      disabled: this.page >= this.pages || this.loading,
      onclick: () => this.selectGroup(this.selectedGroupId, this.page + 1)
    }, 'Suivant →')]);
  }
  view() {
    const selected = this.selectedGroup();
    return m('.ValModerationPane.ValGroupsPane', [m('div.Form-group', [m('label', 'Groupe'), m('select.FormControl', {
      value: this.selectedGroupId,
      onchange: e => {
        this.selectGroup(e.target.value, 1);
      }
    }, [m('option', {
      value: ''
    }, '— Choisir un groupe —'), ...this.groups.map(group => m('option', {
      value: String(group.id)
    }, `${this.groupName(group)} (${group.member_count})`))])]), this.error ? m('.Alert.Alert--error', this.error) : null, this.loading ? m(LoadingIndicator) : null, selected && !this.loading ? m('div', [m('h2', [selected.icon ? m('i', {
      className: selected.icon,
      style: selected.color ? `color:${selected.color};margin-right:8px` : 'margin-right:8px'
    }) : null, this.groupName(selected), m('small', {
      style: 'margin-left:10px;font-weight:normal'
    }, `${this.total} membre${this.total > 1 ? 's' : ''}`)]), this.members.length ? m('table.ValModerationTable', [m('thead', [m('tr', [m('th', 'Membre'), m('th', 'Messages'), m('th', 'Discussions'), m('th', 'Inscrit'), m('th', 'Dernière visite')])]), m('tbody', this.members.map(user => m('tr', [m('td', [m('a', {
      href: app.forum.attribute('baseUrl').replace(/\/$/, '') + '/u/' + encodeURIComponent(user.username)
    }, user.display_name || user.username), m('small', {
      style: 'display:block;opacity:.65;margin-top:2px'
    }, `@${user.username} — #${user.id}`)]), m('td', String(user.comment_count)), m('td', String(user.discussion_count)), m('td', this.formatDate(user.joined_at)), m('td', this.formatDate(user.last_seen_at))])))]) : m('p', 'Aucun membre dans ce groupe.'), this.pagination()]) : null]);
  }
}